import { useDark } from "@vueuse/core";
import { watch } from "vue";

const isDark = useDark({ initialValue: "light" });

watch(isDark, () => {
    document.documentElement.classList.toggle("dark", isDark.value);
});

export function useDarkMode() {
    return isDark;
}